import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Form from "../../components/Form";
import { saveUser } from "../../store/actions/user";
import { withRouter } from "react-router-dom";
import { initFormData, initSwitches, stores } from "../../const";

const EMAIL_REGEX_VALIDATION = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,3})+$/;

const Index = ({ saveUserService, registeredUser, apiInfo, history }) => {
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [formData, setFormData] = useState(initFormData);
  const [switches, setSwitches] = useState(initSwitches);
  const handleOnChange = (prop) => {
    const newFormData = {
      ...formData,
      [prop.target.id]: prop.target.value,
    };
    setFormData(newFormData);
  };
  const handleSwitch = (prop) => {
    setSwitches({
      ...switches,
      [prop.target.id]: prop.target.checked,
    });
  };
  const submitForm = () => {
    saveUserService({ ...formData, store: stores.FALABELLA });
  };

  useEffect(() => {
    if (EMAIL_REGEX_VALIDATION.test(formData.email)) {
      setInvalidEmail(false);
    } else {
      setInvalidEmail(true);
    }
  }, [formData]);

  useEffect(() => {
    if (registeredUser) {
      history.push("/agenda");
    }
  }, [registeredUser]);

  const backToInit = () => {
    history.push("/");
  };

  const goToAgenda = () => {
    history.push("/agenda");
  };
  const handleSelectFragancy = (e) => {
    setFormData({
      ...formData,
      fragancy: e.target.value,
    });
  };
  return (
    <>
      <Form
        {...{
          handleOnChange,
          handleSelectFragancy,
          formData,
          invalidEmail,
          handleSwitch,
          switches,
          submitForm,
          backToInit,
          loadingApi: apiInfo.loading,
          goToAgenda,
          store: stores.FALABELLA,
        }}
      />
    </>
  );
};

const mapStateToProps = (store) => ({
  registeredUser: store.user.savedUser,
  apiInfo: store.api
});

const mapDispatchToProps = (dispatch) => ({
  saveUserService: (props) => dispatch(saveUser(props)),
});

const connected = connect(mapStateToProps, mapDispatchToProps)(Index);
export default withRouter(connected);
